import React from 'react'

const Input = (props) => {
  return (
    <div className='profile-input-box box-shadow'>
      <div>{props.icon}</div>
      <div className='w-100 h-100'>
        <input
          name={props.name}
          placeholder={props.title}
          value={props.value}
          onChange={(e) => props.Onchange(e)}
        />
      </div>
    </div>
  )
}
export default Input
